import { mutatorAction } from 'satcheljs';
import type InlineImageViewState from '../schema/InlineImageViewState';

const deleteImageState = mutatorAction(
    'DeleteImageState',
    (viewState: InlineImageViewState, temporaryId: string) => {
        if (viewState.imageStatusMap[temporaryId]) {
            delete viewState.imageStatusMap[temporaryId];
        }
    }
);

export default deleteImageState;
